import { render } from "./incomingList.vue?vue&type=template&id=96611b42&scoped=true"
import script from "./incomingList.vue?vue&type=script&lang=js"
export * from "./incomingList.vue?vue&type=script&lang=js"

import "./incomingList.vue?vue&type=style&index=0&id=96611b42&scoped=true&lang=css"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96611b42"]])

export default __exports__